import * as React from "react";
import { SeoProps } from "../../interface";
import PageHelmet from "../PageHelmet/PageHelmet";

function Seo({ description, title, canonical, keywords }: SeoProps) {

  const schema = {
    "@context": "https://schema.org",
    "@type": keywords,
    headline: title
  };
  const schemaAsString = JSON.stringify(schema, null, 2);
  return (
    <PageHelmet title={title}>
      <meta charSet="utf-8" />
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta
        name="google-site-verification"
        content="Z38qkiFKdzfnC-QCfoZROCuk-D6uyHJydAmxXPv_GME"
      />
       <meta property="og:site" content="https://www.instagram.com/__stagroo.__/?igsh=b2RiYXVjNDR1MW9n" />
     {canonical&& <link rel="canonical" href={`https://stagroo.com${canonical}/`} />}
     {keywords&&<meta name="keywords" content={keywords} />}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-F2QKBBDSKP"
        defer
      ></script>
      <script
        async
        src="https://pub-37ef75e236694517830c66e6ff42d74f.r2.dev/analytics.js"
        defer
      ></script>
        <script type="application/ld+json" defer>{schemaAsString}</script>
    </PageHelmet>
  );
}
export default Seo;
